import React from 'react';
import PropTypes from "prop-types";
import { TabContent, DashboardDivider, NoDataDiv } from './styles';
import { NoData } from '../commonStyles';
import FlowCard from '../FlowCard/FlowCard';
import InvestmentOptionDetailsMobile from '../../Epics/Investments/Pages/InvestmentOptionDetails/InvestmentOptionDetailsMobile';

export default function TabPaneMobile(props) {
  const {
    tabComponent,
    tabIndex,
    length,
    text,
    tabConfig,
    itemData,
    location,
    clicked,
    getPageTitle,
    exportDataUpdate
  } = props;
  function styleConfig() {
    return {
      alternatingBg: false,
      cardBorder: false,
      cardPadding: true
    };
  }
  switch (tabComponent) {
    case 'card':
      if (props.isLoading) return <div>isLoading</div>;
      return (
        <TabContent>
          {length === 0 ? (
            <NoDataDiv>
              <NoData>{text}</NoData>
            </NoDataDiv>
          ) : (
            itemData &&
            itemData.map((pool, dataIndex) => (
              <>
                <FlowCard
                  key={dataIndex}
                  cardConfig={tabConfig(pool, dataIndex, () => clicked(pool))[tabIndex].config}                  
                  styleConfig={styleConfig()}
                  dataIndex={dataIndex}
                  length={length}
                />
                {dataIndex === itemData.length - 1 ? '' : <DashboardDivider />}
              </>
            ))
          )}
        </TabContent>
      );
    case 'table':
      return (
        <TabContent>
          {length === 0 ? (
            <NoDataDiv>
              <NoData>{text}</NoData>
            </NoDataDiv>
          ) : (
            <InvestmentOptionDetailsMobile
              getPageTitle={getPageTitle}
              exportDataUpdate={exportDataUpdate}
              itemData={itemData}
              tabIndex={tabIndex}
              location={location}
              accountType={props.accountType}
              activeKey={props.activeKey ? props.activeKey : 'Standard'}
            />
          )}
        </TabContent>
      );
    default:
      return 'Not passed component type';
  }
}

TabPaneMobile.propTypes = {
  accountType: PropTypes.any,
  activeKey: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  clicked: PropTypes.func,
  dataIndex: PropTypes.any,
  getPageTitle: PropTypes.any,
  isLoading: PropTypes.any,
  itemData: PropTypes.array,
  length: PropTypes.number,
  location: PropTypes.any,
  tabComponent: PropTypes.any,
  tabConfig: PropTypes.any,
  tabIndex:PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  text: PropTypes.any
}
